import { useQuery, useQueryClient } from '@tanstack/react-query';
import { creditService } from '../services/creditService';

export const useCredits = () => {
  const queryClient = useQueryClient();

  const balanceQuery = useQuery({
    queryKey: ['credits', 'balance'],
    queryFn: creditService.getBalance,
    staleTime: 1000 * 60 * 5, // 5 minutes stale time
    refetchOnWindowFocus: true,
    retry: 1,
  });

  const topupOptionsQuery = useQuery({
    queryKey: ['credits', 'topup-options'],
    queryFn: creditService.getTopupOptions,
    staleTime: 1000 * 60 * 30, // 30 minutes stale time (rarely changes)
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const modulePricingQuery = useQuery({
    queryKey: ['credits', 'module-pricing'],
    queryFn: creditService.getModulePricing,
    staleTime: 1000 * 60 * 30, // 30 minutes stale time (rarely changes)
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const invalidateCredits = async () => {
    await queryClient.invalidateQueries({ queryKey: ['credits'] });
  };

  return {
    balance: balanceQuery.data,
    isLoadingBalance: balanceQuery.isLoading,
    isErrorBalance: balanceQuery.isError,
    balanceError: balanceQuery.error,

    topupOptions: topupOptionsQuery.data || [],
    isLoadingTopupOptions: topupOptionsQuery.isLoading,
    isErrorTopupOptions: topupOptionsQuery.isError,

    modulePricing: modulePricingQuery.data || [],
    isLoadingModulePricing: modulePricingQuery.isLoading,
    isErrorModulePricing: modulePricingQuery.isError,

    invalidateCredits,
  };
};
